import { render, staticRenderFns } from "./initPage.vue?vue&type=template&id=6dc7f17c&scoped=true"
import script from "./initPage.vue?vue&type=script&lang=js"
export * from "./initPage.vue?vue&type=script&lang=js"
import style0 from "./initPage.vue?vue&type=style&index=0&id=6dc7f17c&prod&scoped=true&lang=scss"
import style1 from "./initPage.vue?vue&type=style&index=1&id=6dc7f17c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc7f17c",
  null
  
)

export default component.exports